<template>
  <Nav></Nav>
  <main class="template">
    <back-button></back-button>
    <TemplateEditor :edit="true" :orgSlug="orgSlug" :prjSlug="prjSlug" :tmplSlug="tmplSlug"></TemplateEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import TemplateEditor from '@/components/TemplateEditor.vue';

export default defineComponent({
  name: 'Template',
  components: {
    BackButton,
    Nav,
    TemplateEditor,
  },
  data() {
    return {
      orgSlug: this.$route.params.org_slug as string,
      prjSlug: this.$route.params.prj_slug as string,
      tmplSlug: this.$route.params.tmpl_slug as string,
    };
  },
});
</script>